import { FormGroup, FormControl } from "@angular/forms";
import { Customer, IVR, Number } from "src/app/core/models/customer.model";
import { IVRForm } from "../models/customer";

// A line's call forwarding. A line that has never been saved inherits the customer's legacy
// account-wide setting — mirrors resolveForwarding() in the API, which routes the calls.
export const resolveLineForwarding = (number?: Number | null, customer?: Customer | null): IVR => {
  const ownsSetting = number?.forward !== undefined && number?.forward !== null;
  return {
    _id: number?._id ?? undefined,
    forward: ownsSetting ? !!number!.forward : !!customer?.forward,
    forwardNumber: (ownsSetting ? number!.forwardNumber : customer?.forwardNumber) ?? undefined,
  };
}

export const createIvrForm  = (ivr?: IVR) => {
  if (!ivr) ivr = new IVR();

  const ivrForm = new FormGroup<IVRForm>({
    _id: new FormControl(ivr._id!),
    forward: new FormControl(!ivr.forward!),
    forwardNumber: new FormControl(ivr.forwardNumber!)
  });

  return ivrForm;
}
